import { createAsyncThunk } from "@reduxjs/toolkit";
import * as canadaNowApi from "../../api/requests/canadaNow";

export const fetchLatestNews = createAsyncThunk(
  "canadaNow/fetchLatestNews",
  async () => {
    try {
      const response = await canadaNowApi.getLatestNews();
      return response;
    } catch (error) {
      return error;
    }
  },
);

export const fetchEvents = createAsyncThunk(
  "canadaNow/fetchEvents",
  async (city) => {
    try {
      const response = await canadaNowApi.getAllEvents(city);
      return response;
    } catch (error) {
      return error;
    }
  },
);
// actions/canadaNowActions.js
export const fetchCommunityEvents = createAsyncThunk(
  "canadaNow/fetchCommunityEvents",
  async () => {
    try {
      const response = await canadaNowApi.getCommunityEvents();
      return response;
    } catch (error) {
      return error.response ? error.response.data : error.message;
    }
  },
);
export const addCommunityEvent = createAsyncThunk(
  "canadaNow/addCommunityEvent",
  async (formData) => {
    try {
      const response = await canadaNowApi.postCommunityEvent(formData);
      return response;
    } catch (error) {
      console.log(error);
      return error.response ? error.response.data : error.message;
    }
  },
);
export const fetchStocks = createAsyncThunk(
  "canadaNow/fetchStocks",
  async (symbols) => {
    try {
      const response = await canadaNowApi.getStocks(symbols);
      return response;
    } catch (error) {
      return error;
    }
  },
);
// actions/canadaNowActions.js
export const removeCommunityEvent = createAsyncThunk(
  "canadaNow/removeCommunityEvent",
  async (eventId) => {
    try {
      const response = await canadaNowApi.deleteCommunityEvent(eventId);
      return { status: response.status, eventId }; // Return eventId to filter from state
    } catch (error) {
      return error.response ? error.response.data : error.message;
    }
  },
);
